function Linkmaker (link){
    return (link.replace('https://2021.michael-merkel.eu',''));
}

export default Linkmaker;
